import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputNumeroEndereco = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { numeroEndereco } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("numeroEndereco")
    }

    return (
        <CampoInputTexto
            id="inputNumeroEndereço"
            titulo="Numero*"
            onChange={handleChange}
            name="numeroEndereco"
            value={numeroEndereco}
            label="obrigatório"
            required={true}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputNumeroEndereco
